import { useEffect } from 'react';

function ModalConfirmacion({
  titulo,
  children,
  textoConfirmar,
  onConfirmar,
  onCancelar,
  confirmando,
  confirmarDeshabilitado = false,
  peligro = false,
}) {
  useEffect(() => {
    function alTeclear(evento) {
      if (evento.key === 'Escape' && !confirmando) onCancelar();
    }
    document.addEventListener('keydown', alTeclear);
    return () => document.removeEventListener('keydown', alTeclear);
  }, [onCancelar, confirmando]);

  return (
    <div className="modal-fondo no-imprimir" role="dialog" aria-modal="true" aria-label={titulo}>
      <div className="modal-caja">
        <h2>{titulo}</h2>
        <div className="modal-contenido">{children}</div>
        <div className="modal-acciones">
          <button type="button" className="boton boton-secundario" onClick={onCancelar} disabled={confirmando}>
            Cancelar
          </button>
          <button
            type="button"
            className={`boton ${peligro ? 'boton-peligro' : 'boton-primario'}`}
            onClick={onConfirmar}
            disabled={confirmando || confirmarDeshabilitado}
          >
            {confirmando ? 'Guardando…' : textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalConfirmacion;
